export default "__VITE_ASSET__CER0oMOd__"